import React, { PropsWithChildren } from 'react'

export const ContextMenu = ({children , open , close }:Props) => {

    return(
        <>
        { open &&<>
        <div className='absolute top-0 left-0 z-20 bg-white p-1 -ml-12 shadow border'>
            {children}
        </div>
        <div className='absolute w-screen  z-10 h-full' onClick={close}>
        </div>
        </>
        }
        </>
    )
}
interface Props extends PropsWithChildren<any> {
    open?:boolean
    close:()=>void
}